// extracted by mini-css-extract-plugin
export var infoItem = "_px-2";
export var title = "_px-0";
export var value = "_px-1";